var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_vm._v("\n\tYour user mode is "),_c('b',[_vm._v(_vm._s(_vm.message.raw_modes))])])}
var staticRenderFns = []

export { render, staticRenderFns }